import { canAccessRouteWithSnapshot } from "../../services/routeAccess";

export const buildCuadrillasCapabilities = (snapshot = null) => {
	const session = snapshot?.session || {};
	const canAccessExportacion = Boolean(snapshot?.canAccessExportacion);
	const rol = Number(session?.rol || 0);
	const idCliente = Number(session?.idCliente || 0);
	const idClienteG = Number(session?.idClienteG || 0);
	const rolNombre = String(session?.rolNombre || "").trim().toLowerCase();
	const isClientScopedUser =
		rol !== 980 &&
		(rol === 990 || rolNombre === "cabo cliente" || idCliente > 0 || idClienteG > 0);
	const canExportExcel = canAccessExportacion && !isClientScopedUser;

	return {
		isClientScopedUser,
		canExportExcel,
		canSelectPartes: canExportExcel,
		canEditEstado: !isClientScopedUser,
		canUploadAvatar: !isClientScopedUser,
		canDeleteAvatarLuxand:
			Number(session?.rol || 0) === 986 ||
			canAccessRouteWithSnapshot("/admin", snapshot || undefined),
		canUsePhotoCheck: !isClientScopedUser,
		canOpenOperativos: canAccessRouteWithSnapshot("/cuadrillas/operativos", snapshot || undefined),
	};
};
